import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculators-personalloans-v2.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';
var CalculatorsPersonalloansV2 = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorsPersonalloansV2, _super);
    function CalculatorsPersonalloansV2(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.timeout = null;
        _this.formValid = true;
        return _this;
    }
    CalculatorsPersonalloansV2.prototype.init = function () {
        this.inputs = Array.from(this.element.querySelectorAll('input'));
        this.modifiers = Array.from(this.element.querySelectorAll('.js-calculator-modifier'));
        this.modifierToggles = Array.from(this.element.querySelectorAll('.js-calculator-modifier-toggle'));
        this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll('.js-calculator-radio-group'));
        this.addonToggles = Array.from(this.element.querySelectorAll('.js-calculator-addon-toggle'));
        this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-personalloans-v2-calculate'));
        this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-reset'));
        this.calculator = this.element.querySelector('form');
        this.copyFields = Array.from(this.element.querySelectorAll('.js-copy-field'));
        this.modalLinks = Array.from(this.element.querySelectorAll('.js-calculator-modal'));
        this.termChecker = Array.from(this.element.querySelectorAll("select[name=term]"));
        TooltipsService.initTooltips();
    };
    CalculatorsPersonalloansV2.prototype.bindEvents = function () {
        var _this = this;
        var buttonSteps = Array.from(this.element.querySelectorAll('.accordion span.calculator-personalloans-v2-form__button-step'));
        buttonSteps.forEach(function (element) {
            element.parentElement.removeChild(element);
        });
        this.calculatorSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            // animate back to top
            var btnDoIQualify = Array.from(_this.element.querySelectorAll('.js-calculator-do-i-qualify'));
            if ($(window).width() > 768) {
                $('html,body').animate({
                    scrollTop: $('div.d-md-block div.calculator-personalloans-v2-item').offset().top - 100
                }, 'slow');
                btnDoIQualify.forEach(function (element) {
                    element.classList.remove('button--white');
                    element.classList.remove('button--border-blue');
                    element.classList.add('gradient-orange');
                });
            }
            else if ($(window).width() < 768) {
                $('html,body').animate({
                    scrollTop: $('div.calculator-personalloans-v2-item__box').offset().top
                }, 'slow');
                setTimeout(function () {
                    btnDoIQualify.forEach(function (element) {
                        element.classList.remove('button--white');
                        element.classList.remove('button--border-blue');
                        element.classList.add('gradient-orange');
                    });
                }, 800);
            }
            var allFields = _this.calculator.querySelectorAll('input');
            if (_this.formValid) {
                var button = event.currentTarget;
                var form = button.closest("form");
                _this.doPLT(form);
                // Analytics - Trigger form Complete when the user calculates the results
                _this.analyticsService.dtmFormComplete("complete", "");
            }
        }); });
        this.modifiersRadiosToggle.map(function (item) { return item.addEventListener('click', function (event) {
            var targetField = event.target;
            var visibleGroups = Array.from(_this.element.querySelectorAll('div.' + targetField.getAttribute('data-value')));
            var radioContainers = Array.from(_this.element.querySelectorAll('.js-calculator-radio-group-containers'));
            radioContainers.map(function (item) {
                item.classList.add('calculator-personalloans-v2-form__hidden');
                var inputs = Array.from(item.querySelectorAll('input'));
                inputs.map(function (item) {
                    var getDefaultValue = item.value;
                    if (!getDefaultValue == undefined || getDefaultValue == '') {
                        item.value = '';
                    }
                    else {
                        item.value = getDefaultValue;
                    }
                });
            });
            visibleGroups.map(function (item) {
                item.classList.remove('calculator-personalloans-v2-form__hidden');
            });
        }); });
        this.calculatorReset.map(function (item) { return item.addEventListener('click', function (event) {
            _this.resetInputs(event);
            // animate back to top
            if ($(window).width() > 768) {
                $('html,body').animate({
                    scrollTop: $('div.d-md-block div.calculator-personalloans-v2-item').offset().top - 100
                }, 'slow');
            }
            else {
                $('html,body').animate({
                    scrollTop: $('div.calculators').offset().top - 10
                }, 'slow');
            }
            var btnDoIQualify = Array.from(document.querySelectorAll('.js-calculator-do-i-qualify'));
            btnDoIQualify.forEach(function (element) {
                element.classList.remove('gradient-orange');
                element.classList.add('button--white');
                element.classList.add('button--border-blue');
            });
        }); });
        this.modifierToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleModifiers(event);
        }); });
        this.addonToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleAddons(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('input', function (event) {
            _this.copyField(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('change', function (event) {
            _this.copyField(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModal(event);
        }); });
        // INPUTS
        this.inputs.map(function (item) { return item.addEventListener('focusin', function (event) {
            _this.onFocusInput(event);
        }); });
        this.inputs.map(function (item) { return item.addEventListener('focusout', function (event) {
            _this.outFocusInput(event);
            _this.validateCalculator(event, _this.calculatorSubmit);
            var _valid = Array.from(_this.element.querySelectorAll('.calculator-personalloans-v2-form__error'));
            if (_valid.length > 0) {
                _this.formValid = false;
                _this.calculatorSubmit.map(function (item) {
                    item.classList.add('button--disabled');
                });
            }
            else {
                _this.formValid = true;
                _this.calculatorSubmit.map(function (item) {
                    item.classList.remove('button--disabled');
                });
            }
        }); });
        this.inputs.map(function (item) { return item.addEventListener('keyup', function (event) {
            _this.keyInput(event);
        }); });
        if (this.termChecker) {
            this.termChecker.map(function (item) { return item.addEventListener('change', function (event) {
                _this.checkBaloonPayments(event);
            }); });
        }
    };
    CalculatorsPersonalloansV2.prototype.openModal = function (event) {
        var modalId = event.currentTarget.parentNode.getAttribute('data-modal');
        this.event.emit('openModal', {
            id: modalId
        });
    };
    CalculatorsPersonalloansV2.prototype.copyField = function (event) {
        var fieldParentContainer = this.findFieldCopy(event.currentTarget.parentNode);
        var copyValue = parseFloat(event.currentTarget.value);
        var fieldName = fieldParentContainer.getAttribute('data-target');
        var fields = fieldParentContainer.querySelectorAll(".js-" + fieldName);
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].classList.contains('js-not-zero')) {
                if (copyValue == 0) {
                    copyValue = 1;
                }
            }
            fields[i].value = copyValue;
        }
        // Form form start (if not started yet) when slider is being interacted with
        this.analyticsService.dtmTriggerFormStart(fields[0]);
    };
    CalculatorsPersonalloansV2.prototype.findFieldCopy = function (parent) {
        while ((parent = parent.parentElement) && !parent.classList.contains('js-copy-fields'))
            ;
        return parent;
    };
    CalculatorsPersonalloansV2.prototype.toggleModifiers = function (event) {
        event.preventDefault();
        var targetModifierId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetModifier = this.element.querySelector("#" + targetModifierId);
        if (targetModifier.classList.contains('calculator-personalloans-v2-form__modifiers--open')) {
            targetModifier.classList.remove('calculator-personalloans-v2-form__modifiers--open');
            event.currentTarget.classList.add('calculator-personalloans-v2-form__link--open');
        }
        else {
            targetModifier.classList.add('calculator-personalloans-v2-form__modifiers--open');
            event.currentTarget.classList.remove('calculator-personalloans-v2-form__link--open');
        }
    };
    CalculatorsPersonalloansV2.prototype.toggleAddons = function (event) {
        event.preventDefault();
        if (event.currentTarget.classList.contains('link--disabled')) {
            return;
        }
        var targetAddonId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetAddon = this.element.querySelector('#' + targetAddonId);
        var targetInput = targetAddon.querySelector("input");
        var _tmpText = event.currentTarget.querySelector(".link__text");
        var _coAppText = this.element.querySelector(".co_app_text");
        if (targetAddon.classList.contains("calculator-personalloans-v2-form__addon--open")) {
            if (targetInput) {
                targetInput.value = "0";
                targetInput.placeholder = "0";
            }
            targetAddon.classList.remove('calculator-personalloans-v2-form__addon--open');
            _tmpText.innerText = "+ Add co-applicant's income";
            if (_coAppText) {
                _coAppText.innerText = "";
            }
        }
        else {
            if (targetInput) {
                targetInput.value = "0";
                targetInput.placeholder = "0";
            }
            targetAddon.classList.add('calculator-personalloans-v2-form__addon--open');
            _tmpText.innerText = "- Remove co-applicant's income";
            if (_coAppText) {
                _coAppText.innerText = "(including co-applicant)";
            }
        }
    };
    CalculatorsPersonalloansV2.prototype.resetInputs = function (event) {
        event.preventDefault();
        var errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
        errorLabels.map(function (item) {
            var parent = item;
            $(parent).removeClass('calculator-personalloans-v2-form__error');
            $(parent).find('div.calculator-personalloans-v2-form__error-label').remove();
        });
        this.calculator.reset();
        this.formValid = true;
        this.resetValues(this.calculator);
        this.inputs.map(function (item) {
            if (item.getAttribute('type') != 'radio') {
                item.setAttribute('data-value', 0);
                item.setAttribute('placeholder', 0);
            }
        });
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmRestartForm();
    };
    CalculatorsPersonalloansV2.prototype.onFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        var _value = parseFloat(field.value);
        var min = parseFloat(field.getAttribute('min'));
        var max = parseFloat(field.getAttribute('max'));
        if (min && max) {
            if ((_value < min) && (_value > max)) {
                field.value = "";
            }
        }
        else {
            if (_value == 0) {
                field.value = "";
            }
        }
    };
    CalculatorsPersonalloansV2.prototype.outFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        if (!field.classList.contains('js-copy-field')) {
            var value = field.getAttribute('data-value');
            // field.value = value;
            if (field.value == '') {
                field.value = value;
            }
        }
        if (field.value == '') {
            field.value = 0;
        }
    };
    CalculatorsPersonalloansV2.prototype.keyInput = function (event) {
        event.preventDefault();
        this.formValid = true;
        var field = event.target;
        var value = field.value;
        if (!field.classList.contains('js-copy-field')) {
            field.setAttribute('data-value', value);
            field.setAttribute('placeholder', value);
        }
        this.formValid = this.validateCalculator(event, this.calculatorSubmit);
    };
    CalculatorsPersonalloansV2.prototype.checkBaloonPayments = function (event) {
        var value = event.currentTarget.value;
        var balloonInput = Array.from(this.element.querySelectorAll(".js-balloon"));
        if (balloonInput.length > 0) {
            if (value == '84') {
                balloonInput.forEach(function (element) {
                    element.value = "0";
                    element.placeholder = "0";
                    element.max = "0";
                    element.min = "0";
                    element.setAttribute("data-value", "0");
                });
            }
            else {
                balloonInput.forEach(function (element) {
                    element.value = "1";
                    element.placeholder = "1";
                    element.max = "40";
                    element.min = "1";
                    element.setAttribute("data-value", "1");
                });
            }
        }
    };
    //CALCULATOR SERVICES
    CalculatorsPersonalloansV2.prototype.doPLT = function (form) {
        var total = 0;
        var loanamount = form.querySelector('input[name=loan_amount]');
        total = parseFloat(loanamount.value);
        var interest = form.querySelector('input[name=variable_interest_rate]');
        var term = form.querySelector('input[name=term]');
        var output_borrow = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
        var output_months = document.querySelectorAll('span.js-calculator-loan-period-pl1');
        var output_date = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1');
        var output_fees = document.querySelectorAll('span.js-calculator-total-interest-pl1');
        var output_date2 = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1-2');
        var answer = this.PLTMonthlyRepayments(total, interest.value, term.value);
        [].slice.call(output_borrow).forEach(function (div) {
            div.innerHTML = answer.estimatedMonthlyRepayment;
        });
        [].slice.call(output_date).forEach(function (div) {
            div.innerHTML = answer.date;
        });
        [].slice.call(output_fees).forEach(function (div) {
            div.innerHTML = answer.totalInterest;
        });
        if (output_date2) {
            [].slice.call(output_date2).forEach(function (div) {
                div.innerHTML = 'Today';
            });
        }
    };
    // PERSONAL LOANS
    CalculatorsPersonalloansV2.prototype.PLTMonthlyRepayments = function (loanamount, loaninterest, loanterm) {
        if (loanamount === void 0) { loanamount = 0; }
        if (loaninterest === void 0) { loaninterest = 0; }
        if (loanterm === void 0) { loanterm = 10.25; }
        var initiationFee = Math.min(1050, 165 + 0.1 * (loanamount - 1000)) * 1.15;
        var serviceFee = 60 * 1.15;
        var normalValue = loanamount / loanterm;
        normalValue = this.round(normalValue, 2);
        var final = -this.pmt_vaf(loaninterest / 1200, loanterm, (loanamount + initiationFee), 0, 0) + serviceFee;
        final = this.round(final, 2);
        var interestTotal = this.round((final - normalValue), 2);
        var todaysDate = new Date();
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + 1, 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return {
            date: "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear(),
            iFee: initiationFee,
            sFee: serviceFee,
            totalInterest: this.formatter(interestTotal),
            estimatedMonthlyRepayment: this.formatter(final)
        };
    };
    CalculatorsPersonalloansV2.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorsPersonalloansV2.prototype.pmt_vaf = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    // FORMATTERS
    CalculatorsPersonalloansV2.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    // RESET VALUES	- OUTPUTS
    CalculatorsPersonalloansV2.prototype.resetValues = function (form) {
        switch (form.id) {
            case 'calculator-personal_loans_v2':
                var loanamount = form.querySelector('input[name=loan_amount]');
                var output_borrow_plt = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
                var output_date = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1');
                var output_fees = document.querySelectorAll('span.js-calculator-total-interest-pl1');
                var output_date2 = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1-2');
                [].slice.call(loanamount).forEach(function (div) {
                    div.innerHTML = '300000';
                });
                [].slice.call(output_borrow_plt).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_date).forEach(function (div) {
                    div.innerHTML = '0';
                });
                [].slice.call(output_fees).forEach(function (div) {
                    div.innerHTML = '0';
                });
                if (output_date2) {
                    [].slice.call(output_date2).forEach(function (div) {
                        div.innerHTML = '0';
                    });
                }
                break;
            default:
                break;
        }
    };
    //
    //
    // PERSONAL LOANS CUSTOM CALCULATOR VALIDATIONS
    //
    //
    CalculatorsPersonalloansV2.prototype.validateCalculator = function (event, button) {
        // varaibles
        event.preventDefault();
        var field = event.target;
        var formValid = true;
        var fieldValue = field.value;
        var fieldAddon = field;
        var required = field.getAttribute('data-validation-required');
        var title = field.getAttribute('data-validation-title');
        var minimum = parseFloat(field.getAttribute('min'));
        var maximum = parseFloat(field.getAttribute('max'));
        var greaterThan = field.getAttribute('data-validation-greater-than');
        var lessThan = field.getAttribute('data-validation-less-than');
        // removeErrors
        $(field).closest('.calculator-personalloans-v2-form__group').removeClass('calculator-personalloans-v2-form__error');
        $(field).closest('.calculator-personalloans-v2-form__group').find('div.calculator-personalloans-v2-form__error-label').remove();
        // required
        if (required == "true") {
            if (fieldValue.length == 0) {
                formValid = false;
                if (minimum) {
                    if (maximum) {
                        if (title) {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                        }
                        else {
                            this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                        }
                    }
                    else {
                        this.validateCalculatorError(event, 'Enter an amount');
                    }
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount');
                }
            }
        }
        // min
        if (minimum > parseFloat(fieldValue)) {
            formValid = false;
            if (title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
            }
            else if (!title && maximum) {
                this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
            }
            else if (!title && !maximum) {
                this.validateCalculatorError(event, 'Enter an amount');
            }
        }
        // max
        if (maximum > 0) {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
                }
            }
        }
        else {
            if (maximum < parseFloat(fieldValue)) {
                formValid = false;
                if (title) {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0 ' + title);
                }
                else {
                    this.validateCalculatorError(event, 'The maximum you can insert is 0');
                }
            }
        }
        // greater than
        if (greaterThan) {
            var fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
            if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
                formValid = false;
                this.validateCalculatorError(event, 'Enter an amount greater than the expenses field');
            }
        }
        // less than
        if (lessThan) {
            var fieldsLessThan = $(field).closest('form').find('input[name=' + lessThan + ']');
            if (fieldsLessThan.length > 1) {
                var amount_1 = 0;
                $(fieldsLessThan).each(function (index) {
                    var valueElement = $(this).val();
                    if (!valueElement) {
                        amount_1 = amount_1 + 0;
                    }
                    else {
                        amount_1 = amount_1 + parseFloat(valueElement);
                    }
                });
                if (parseFloat(fieldValue) >= amount_1) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
            else {
                if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
                    formValid = false;
                    this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
                }
            }
        }
        return formValid;
    };
    CalculatorsPersonalloansV2.prototype.validateCalculatorError = function (event, message) {
        if (message === void 0) { message = ''; }
        event.preventDefault();
        var field = event.target;
        var closestGroup = field.closest('.calculator-personalloans-v2-form__group');
        $(closestGroup).addClass('calculator-personalloans-v2-form__error').append('<div class="calculator-personalloans-v2-form__error-label">' + message + '</div>');
    };
    CalculatorsPersonalloansV2.prototype.formatNumbers = function (nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    };
    return CalculatorsPersonalloansV2;
}(Base));
export { CalculatorsPersonalloansV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-personalloans-v2/calculators-personalloans-v2.component.ts
// module id = 809
// module chunks = 0